import React from 'react'
import { useSelector } from 'react-redux'
import { isEmpty, pick } from 'lodash'
import { WrapIndication, IndicationLabel, CellWithButtonStyles } from './Style'
import { naLabel, ratingColors5, ratingColors6, ratingListLabel, ratingListTheme } from 'keys/rating'
import { gTheme } from 'styles/theme'
import { statuses } from 'keys'
import { Done, NotificationsNone, Remove } from '@mui/icons-material'
import { visibilityStatuses1 } from 'keys/visibilityStatuses'
import { secretStorage } from 'config'
import { Chip } from 'components/Form'

const RateAndAccuracyLabelCell = (props) => {
    const { row, column } = props
    const { meta } = column.columnDef
    const { rating, status, assessment_hidden } = row.original || {}
    const { scoreRatingMethods } = useSelector(state => state.rating)
    const is_superuser = secretStorage.getItem("user")?.is_superuser

    const labels = meta.ratingLabels || ratingListLabel

    const indicationIcon = {
        "noraml": {
            icon: Done,
            color: "success"
        },
        "warning": {
            color: "error",
            icon: NotificationsNone,
        },
        "nodata": {
            icon: Remove,
            color: "ligthGray"
        }
    }

    const { warning, noraml, nodata } = indicationIcon

    const ratingFields = pick(rating, [meta?.id, meta?.index])
    let ratingIndex = ratingFields[meta?.index]
    let ratingId = ratingFields[meta?.id]
    let currentScoreRatingMethod

    if (status === statuses.brokenFile)
        currentScoreRatingMethod = {
            label: naLabel
        }

    else {
        if (isEmpty(scoreRatingMethods))
            currentScoreRatingMethod = {
                themeColor: ratingListTheme[ratingIndex - 1],
                label: labels[ratingIndex - 1]
            }
        else {
            currentScoreRatingMethod = scoreRatingMethods?.[ratingId]
            ratingIndex = currentScoreRatingMethod?.index
        }
    }

    const color = gTheme?.[currentScoreRatingMethod?.themeColor]?.main || 'ligthGray'
    const hiddenAssessment = assessment_hidden && !is_superuser

    return (
        <CellWithButtonStyles>
            <WrapIndication>
                <IndicationLabel color={hiddenAssessment || color}>
                    {hiddenAssessment ? currentScoreRatingMethod?.label :
                        <Chip color={ratingColors5[ratingIndex - 1]} bg={ratingColors6[ratingIndex - 1]}>
                            {currentScoreRatingMethod?.label}
                        </Chip>}
                </IndicationLabel>
            </WrapIndication>
        </CellWithButtonStyles>
    )

}

export default RateAndAccuracyLabelCell